export const MAXIMUM_LIST_PRICE_IN_DOLLARS = 10000;
